define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var PortletView = require('modules/portlet/portlet.view');
    var Form = require('class/form.class');
    var user = require('user');
    var core = require('core');
    const config = require('config');
    var dispatcher = require('bundle').dispatcher;
    var launcher = require('modules/launcher/launcher');
    const phoneMixin = require('mixins/parx-theme/phone.mixin');
    const dateMixin = require('portlets/registration/mixins/date.mixin');

    module.exports = PortletView.extend({

        mixins: [dateMixin, phoneMixin],

        templateName: 'updatedetails',

        accessRules: {
            allow: ['user']
        },

        events: {
            'input input': 'checkForChanges',
            'change select': 'checkForChanges',
            'submit form': 'updateUserDetails',
            ...dateMixin.additionalEvents,
            ...phoneMixin.additionalEvents
        },

        userDetails: {},

        render: function() {
            this.$el.html(this.tmpl(this.templateName));

            // It's a hack. One day we should move all this logic to model
            this.getUserDetails();

            return this;
        },

        getUserDetails: function() {
            return Promise.all([user.fetchUserDetails(), window.Playtech.API.user.getPlayerTags()])
                .then(function([userDetails, playerTags]) {
                    this.userDetails = userDetails?.data
                        ? _.clone(userDetails.data)
                        : {};

                    // remove '2' prefix from IMS taxResidenceRegion value, code value should be 2 characters long
                    if (this.userDetails.taxResidenceRegion?.length === 3) {
                        this.userDetails.taxResidenceRegion = this.userDetails.taxResidenceRegion.substr(1, 2);
                    }

                    if (this.userDetails.phone?.startsWith('+1')) {
                        this.userDetails.phone = this.userDetails.phone.substring(2);
                    }

                    if (this.userDetails.cellphone?.startsWith('+1')) {
                        this.userDetails.cellphone = this.userDetails.cellphone.substring(2);
                    }

                    this.renderUserDetails(this.userDetails, playerTags?.data?.tags || []);
                }.bind(this))
                .catch(this.renderNetworkError.bind(this));
        },

        renderUserDetails: function(data, playerTags) {
            const userDetails = { ...data };
            const phoneData = userDetails.phone || userDetails.cellphone;
            const cellphoneData = userDetails.cellphone || userDetails.phone;
            const { ageVerificationStatus } = userDetails;
            const kycMadeOnce = playerTags.find(tag => tag.name.toLowerCase() === 'risk/kyc_x1');
            const kycMadeTwice = playerTags.find(tag => tag.name.toLowerCase() === 'risk/kyc_x2');
            const enabledPrimaryUserData = ageVerificationStatus !== 'passed' && kycMadeOnce && !kycMadeTwice;
            const enabledSecondaryUserData = ageVerificationStatus === 'passed' && !kycMadeOnce && !kycMadeTwice;

            this.$el.html(this.tmpl(this.templateName, {
                ...userDetails,
                phone: phoneMixin.getFormattedPhone(phoneData),
                cellphone: phoneMixin.getFormattedPhone(cellphoneData),
                states: this.getStates(),
                enabledPrimaryUserData,
                enabledSecondaryUserData
            }));

            this.form = new Form(this.$('#update-details'), {
                validationConfig: this.options.config.validation
            });

            this.submit = this.$('.btn[type=submit]')[0];
        },

        // You can define this method in your licensee file for processing form data
        getData: function(changedData, allData) {
            const { day, month, year, phone, cellphone } = changedData;
            const phoneData = phone || cellphone;
            const cellphoneData = cellphone || phone;

            if (phoneData && cellphoneData) {
                changedData = { ...changedData, phone: phoneMixin.getPhoneBeforeSend(phoneData), cellphone: phoneMixin.getPhoneBeforeSend(cellphoneData) };
            }

            if (changedData.countrycode || changedData.countryCode) {
                changedData = _.extend(changedData, {
                    countrycode: changedData.countrycode || changedData.countryCode
                });
            }

            if (day || month || year) {
                changedData.birthdate = `${year || allData.year}-${month || allData.month}-${day || allData.day}`;

                delete changedData.day;
                delete changedData.month;
                delete changedData.year;
            }

            return _.chain(changedData)
                .omit('countryCode', 'name', 'address4')
                .value();
        },

        checkForChanges: function() {
            if (user.isFastRegistered()) {
                return this.submit.disabled = false;
            }

            this.submit.disabled = !this.form.isDataChanged();
        },

        updateUserDetails: function(e) {
            e.preventDefault();

            this.hideKeyboard();
            this.form.validate(null, null, null, true)
                .done(this.successValidation.bind(this));
        },

        successValidation: function(data) {
            this.changedUserDetails = this.regulationFieldsOnSaveFilter(this.getData(this.form.getChangedData(), data));

            this.userDetails = _.extend({}, this.userDetails, this.changedUserDetails);

            this.submit.disabled = true;
            this.form.showLoading();
            user.save(null, { userDetails: this.changedUserDetails })
                .always(this.form.hideLoading.bind(this.form))
                .done(this.successUpdate.bind(this))
                .fail(this.errorUpdate.bind(this));
        },

        /**
         * Needed for request pin code within Two Factor Auth popup
         */
        resendTwoFactorAuthPin: function() {
            return user.save(null, { userDetails: this.changedUserDetails });
        },

        onTwoFactorAuthSuccess: function() {
            this.submit.disabled = true;
            this.form.showLoading();

            return user.save(null, { userDetails: this.changedUserDetails })
                .always(this.form.hideLoading.bind(this.form))
                .done(this.successUpdate.bind(this))
                .fail(this.errorUpdate.bind(this));
        },

        showTwoFactorAuthPopup: function() {
            window.Playtech.API.popup.showPopup('twoFactorAuthentication', {
                onCancel: () => {
                    dispatcher.dispatch('2fa-popup-closed', 'change-details');
                },
                onSuccess: this.onTwoFactorAuthSuccess.bind(this),
                resendHandler: this.resendTwoFactorAuthPin.bind(this)
            });
        },

        regulationFieldsOnSaveFilter: function(data) {
            return data;
        },

        successUpdate: function() {
            const { email, ...otherFields } = this.form.getChangedData();

            this.changedUserDetails = {};
            this.form.updateFormData();
            this.getUserDetails();

            if (!email) {
                this.showInfo({ content: this.translate('playtech.mobile.system.update-my-details.message') });
            } else {
                window.Playtech.API.popup.showPopup({
                    buttons: [],
                    className: 'update-my-details-success-popup',
                    content: this.translate(
                        `playtech.mobile.system.update-my-details.email.${Object.keys(otherFields).length ? 'with.data.' : ''}message`
                    )
                });
            }

            this.afterContinueRegisterAction();
        },

        errorUpdate: function(response) {
            if (response?.data?.errorCode === 303) {
                this.submit.disabled = false;
                this.showTwoFactorAuthPopup();

                return;
            }

            this.submit.disabled = false;
            this.form.showErrorMessages({
                content: response.data.errorMessage
            });
        },

        afterContinueRegisterAction: function() {
            var data = user.get('afterContinueRegisterAction');

            if (!data) {
                return true;
            }

            user.unset('afterContinueRegisterAction');

            if (data.action === 'launchGame') {
                return launcher.launchGame(data.options.code, data.options.mode, data.options.queryString);
            }

            return core.navigate(data.url || '/');
        },
        getStates: function() {
            const states = config.get('dynamicTags').DTAG_UPDATE_DETAILS_STATES;

            try {
                return JSON.parse(states);
            } catch (error) {
                console.warn('UPDATE_DETAILS_STATES D-tag should be configured properly, like: ' +
                    '[{ key: "Alabama", value: "US-AL"}, { key: "Alaska", value: "US-AK"}]');

                return [];
            }
        }
    });
});
